import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/rendez-vous')({
  component: () => <Outlet />,
});
